import { render, staticRenderFns } from "./TwoStepCaptcha.vue?vue&type=template&id=4fe1da8d&scoped=true&"
import script from "./TwoStepCaptcha.vue?vue&type=script&lang=js&"
export * from "./TwoStepCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./TwoStepCaptcha.vue?vue&type=style&index=0&id=4fe1da8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1da8d",
  null
  
)

export default component.exports